import { render } from "./sidebar-status-bar.vue?vue&type=template&id=47bd9a54&ts=true"
import script from "./sidebar-status-bar.vue?vue&type=script&lang=ts"
export * from "./sidebar-status-bar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__